module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Kitchen-scale-ac9b33cb917f5c36f773ece11ce0bca5.svg";